import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/jobs")({
  staticData: { pageTitle: "breadcrumbs.jobs" },
  component: JobsLayout,
});

function JobsLayout() {
  return <Outlet />;
}
